import Vue from 'vue';
import App from './App.vue';

import './firebaseApp';
import * as firebase from 'firebase/app';
require('firebase/auth');

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import VuetifyConfirm from 'vuetify-confirm';

Vue.use(Vuetify);
Vue.use(Datetime);
Vue.use(VuetifyConfirm, {
  width: 300,
  property: '$confirm'
});

import store from './store/store';
import router from './router/router';

import './assets/site.css';

Vue.config.productionTip = false;

store.dispatch("authStateChanged").then(user => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});